import { EEthereumNetworkId, RPC_URLS_BY_NETWORK } from '@ankr.com/provider';
import { EBlockchain, ethNetworkIdByBlockchainMap } from 'multirpc-sdk';

import {
  ARBITRUM_RPC_URL,
  ARBITRUM_SEPOLIA_TESTNET_RPC_URL,
  BSC_RPC_URL,
  BSC_TESTNET_RPC_URL,
  ETH_HOLESKY_RPC_URL,
  ETH_RPC_URL,
  FANTOM_RPC_URL,
  FANTOM_TESTNET_RPC_URL,
  OPTIMISIM_RPC_URL,
  OPTIMISM_TESTNET_RPC_URL,
  POLYGON_RPC_URL,
  SCROLL_RPC_URL,
  SCROLL_SEPOLIA_TESTNET_RPC_URL,
} from '../constants';

const RPC_URLS_BY_NETWORK_OVERRIDE = {
  [EEthereumNetworkId.arbitrumSepoliaTestnet]: ARBITRUM_SEPOLIA_TESTNET_RPC_URL,
  [EEthereumNetworkId.arbitrum]: ARBITRUM_RPC_URL,
  [EEthereumNetworkId.fantomTestnet]: FANTOM_TESTNET_RPC_URL,
  [EEthereumNetworkId.fantom]: FANTOM_RPC_URL,
  [EEthereumNetworkId.holesky]: ETH_HOLESKY_RPC_URL,
  [EEthereumNetworkId.mainnet]: ETH_RPC_URL,
  [EEthereumNetworkId.optimismTestnet]: OPTIMISM_TESTNET_RPC_URL,
  [EEthereumNetworkId.optimism]: OPTIMISIM_RPC_URL,
  [EEthereumNetworkId.polygon]: POLYGON_RPC_URL,
  [EEthereumNetworkId.scrollTestnet]: SCROLL_SEPOLIA_TESTNET_RPC_URL,
  [EEthereumNetworkId.scroll]: SCROLL_RPC_URL,
  [EEthereumNetworkId.smartchainTestnet]: BSC_TESTNET_RPC_URL,
  [EEthereumNetworkId.smartchain]: BSC_RPC_URL,
};

export const getRpcUrlByNetwork = (network: EBlockchain) => {
  const ethNetworkId = ethNetworkIdByBlockchainMap[network];

  const urls = { ...RPC_URLS_BY_NETWORK, ...RPC_URLS_BY_NETWORK_OVERRIDE };

  return urls[ethNetworkId as keyof typeof RPC_URLS_BY_NETWORK];
};
